import type { ChatMessageProps } from '../components/ChatMessage';
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ChatMessageType } from '../components/ChatMessage';

export const useChat = () => {
  const [messages, setMessages] = useState<ChatMessageProps[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [placeholder, setPlaceholder] = useState('');
  const [suggestions, setSuggestions] = useState<string[]>([]);

  const pushMessage = (message: string | React.ReactNode, isUser = false) => {
    const newMessage: ChatMessageProps = {
      id: uuidv4(),
      content: message,
      isUser,
      type: ChatMessageType.MESSAGE,
    };
    setMessages((prev) => [...prev, newMessage]);
  };

  const pushComponent = (component: React.ReactNode) => {
    const newMessage: ChatMessageProps = {
      id: uuidv4(),
      content: component,
      type: ChatMessageType.COMPONENT,
    };
    setMessages((prev) => [...prev, newMessage]);
  };

  const clearMessages = () => {
    setMessages([]);
  };

  return {
    messages,
    pushMessage,
    pushComponent,
    clearMessages,
    isLoading,
    setIsLoading,
    placeholder,
    setPlaceholder,
    suggestions,
    setSuggestions,
  };
};
